import { experienceVisibilityGuard } from '@rma/dashboard/layout/public/api-experience';
import { billingRoutes } from './billing.routes';

// These are routes that I haven't quite fi
export const accountRoutes = [
  {
    path: 'billing',
    canActivate: [experienceVisibilityGuard((s) => s.showBillingAndSubs$)],
    children: billingRoutes,
  },
  {
    path: 'manage-account',
    loadChildren: () => import('@rma/dashboard/account/manage-account'),
  },
  {
    path: 'notifications',
    loadComponent: () => import('@rma/dashboard/notification-bell/view-all-notifications'),
  },
  {
    path: 'onboarding',
    children: [{ path: '**', redirectTo: '/' }],
  },
];
